import {commentSchema} from '../../../components/comments/editor/commentSchema';

function normalizeLineBreaks(text = '') {
    return String(text).replace(/\r\n?/g, '\n');
}

function buildParagraphContentFromText(text = '') {
    const normalizedText = normalizeLineBreaks(text);
    if (!normalizedText) {
        return [];
    }

    const segments = normalizedText.split('\n');
    const content = [];

    segments.forEach((segment, index) => {
        if (segment) {
            content.push({type: 'text', text: segment});
        }

        if (index < segments.length - 1) {
            content.push({type: 'hard_break'});
        }
    });

    return content;
}

export function buildCommentDocFromPlainText(text = '') {
    return {
        type: 'doc',
        content: [{
            type: 'paragraph',
            content: buildParagraphContentFromText(text),
        }],
    };
}

function readInlineNode(node) {
    if (!node) {
        return '';
    }

    switch (node.type?.name) {
    case 'text':
        return node.text || '';
    case 'hard_break':
        return '\n';
    case 'userMention': {
        const label = node.attrs?.label || node.attrs?.name || node.attrs?.email || 'mention';
        return `@${label}`;
    }
    default:
        return Array.isArray(node.content?.content)
            ? node.content.content.map(readInlineNode).join('')
            : '';
    }
}

export function extractPlainTextFromCommentDoc(docJson) {
    if (!docJson || typeof docJson !== 'object') {
        return '';
    }

    try {
        const doc = commentSchema.nodeFromJSON(docJson);
        return doc.content.content
            .map((blockNode) => blockNode.type?.name === 'paragraph'
                ? blockNode.content.content.map(readInlineNode).join('')
                : readInlineNode(blockNode))
            .join('\n')
            .replace(/\u00A0/g, ' ');
    } catch (_) {
        return '';
    }
}

